import { Field, Float, ID, InputType } from 'type-graphql'

/**
 * A serial number picked as scrapped on a production line.
 */
@InputType()
export class ScrappedSerialArgs {
  @Field(() => ID)
  _id: string
}

/**
 * One production line to scrap, matched to the production's `items` by line `_id`.
 * Omit `inventoryBySerialNumbers` for a line without serial numbers.
 */
@InputType()
export class ScrappedItemArgs {
  @Field(() => ID)
  _id: string

  @Field(() => Float)
  quantity: number

  @Field(() => [ScrappedSerialArgs], { nullable: true })
  inventoryBySerialNumbers?: ScrappedSerialArgs[]
}

/**
 * The `args` payload of a `changeWorkOrderStatus` move to Destructed. It rides the `GraphQLJSON`
 * `StateTransitionArgs.args` field shared by every entity's transition, so GraphQL does not
 * coerce it — `ResolveScrappedItems` guards the list shape at the boundary.
 */
@InputType()
export class DestructedTransitionArgs {
  @Field(() => [ScrappedItemArgs], { nullable: true })
  scrappedItems?: ScrappedItemArgs[]
}
